var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('v-container', [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline text-center pb-0px pb-md-20px"
  }, [_c('h2', {
    staticClass: "tit tit--lg"
  }, [_vm._v("회원가입")])]), _c('div', {
    staticClass: "contents-area__inner"
  }, [_c('router-join')], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }